// src/componentes/ModalDelete.jsx
import React from 'react';
import { Modal } from 'antd';
import useApi from '../../hooks/useApi';

const ModalDelete = ({ visible, id, onCancel, onSuccess }) => {
  const { callApi: deleteDashboard } = useApi(`https://vision.alfama.com/api/delete/dashboards/grupo/${id}`, {
    method: 'DELETE',
    includeToken: true,
    successMessage: 'Dashboard excluído com sucesso!',
    errorMessage: 'Erro ao excluir dashboard'
  });

  const handleConfirm = async () => {
    try {
      await deleteDashboard();
      onCancel(); // Primeiro fecha o modal
      onSuccess(); // Depois atualiza a lista
    } catch (error) {
      console.error('Erro ao excluir dashboard:', error);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-500">
          Confirmação de Exclusão
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Confirmar"
      cancelText="Cancelar"
      okButtonProps={{ 
        danger: true,
        className: 'bg-red-500'
      }}
    >
      <p>Tem certeza que deseja excluir o ID: <strong>{id}</strong>?</p>
      <p>Esta ação não poderá ser desfeita.</p>
    </Modal>
  );
};

export default ModalDelete;
